import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Box from 'components/box';
import {SearchFail, UniversalSearchWrapper} from 'components/common';
import ServicesList from './services-list';
import Spinner from 'spinner';
import Pagination from 'pagination';
import {ButtonDefault, LinkDefault} from 'components/buttons';
import {PageHead} from 'components/header/components';
import Input from 'form/input';


import {searchServices} from 'redux/actions/admin/services';

const mapStateToProps = (state) => ({
  services: state.adminService.get('servicesList'),
  isLoading: state.adminService.get('servicesIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
	onSearch: (name, offset) => dispatch(searchServices(name, 12, offset))
});

class ServicesAll extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: ""
    }

    this.changeSearchName = this.changeSearchName.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  onSubmitForm = event => {
    event.preventDefault();
    this.props.match.params.page != 1
      ? this.props.history.push(`/admin/services/1`)
      : this.props.onSearch(this.state.name)
  }

  componentDidMount() {
		const page = this.props.match.params.page || 1;
		const offset = 12 * (page - 1);
		this.props.onSearch(this.state.name, offset)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 12 * (page - 1);
			this.props.onSearch(this.state.name, offset)
		}
	}

	render() {

    if (this.props.services === undefined) {
      return <Spinner/>
    }

		return (
      <div>
			<Box>
				<PageHead>
					<h2>Реєстр послуг</h2>
					<LinkDefault to="/admin/services/create">Створити послугу</LinkDefault>
				</PageHead>

        <UniversalSearchWrapper onSubmit={this.onSubmitForm}>
          <Input
            block
            placeholder="Введіть назву послуги"
            label="Пошук за назвою послуги"
            value={this.state.name}
            onChange={this.changeSearchName}
          />
          <ButtonDefault type="submit" value="Пошук" />
        </UniversalSearchWrapper>
  
				{this.props.services.get('results').size > 0
						? (<div>
							{
								this.props.isFetching
									? (<Spinner/>)
									: (<ServicesList services={this.props.services.get('results')}/>)
							}

						</div>)
						: (
							<SearchFail>Послуги відсутні</SearchFail>
						)}

				<Pagination counts={this.props.services.get('count')} path={`/admin/services/`} matched={this.props.match.params.page} limits={12}/>
			</Box>
		</div>
  )
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServicesAll));



// WEBPACK FOOTER //
// ./src/admin/services/services.js